import { siteInfo } from '@/mocks/siteInfo';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const faqItems = [
    {
      question: '爆料专区的新闻来源是什么？',
      answer: '爆料专区的新闻来源于多渠道的独立信息源，包括业内爆料人、匿名投稿、记者调查以及公开信息整理。我们坚持多方核实原则，确保每一条爆料的真实性和可靠性。',
    },
    {
      question: '如何向爆料专区投稿？',
      answer: '您可以通过页面底部的"我要爆料"按钮或发送邮件至我们的官方邮箱提交爆料信息。我们承诺对爆料人身份进行最高级别的匿名保护，绝不泄露任何个人信息。',
    },
    {
      question: '爆料专区的内容更新频率是怎样的？',
      answer: '我们的编辑团队7×24小时全天候运作，每天发布数十条独家爆料内容。重大突发事件发生后，我们会在第一时间进行核实并发布，确保您不错过任何重要资讯。',
    },
    {
      question: '如果发现爆料内容不实怎么办？',
      answer: '我们设有专门的纠错机制。如果您发现任何不实内容，请通过邮件或页面联系方式向我们反馈，我们的编辑团队会在24小时内进行核查，如确认有误将及时更正并公示。',
    },
    {
      question: '爆料专区是否收费？',
      answer: '爆料专区对所有用户完全免费。我们的使命是让每一个人都能第一时间获取真实、劲爆的资讯内容。未来如有增值服务，会提前在网站公示。',
    },
    {
      question: '我可以转载爆料专区的内容吗？',
      answer: '爆料专区的内容受版权保护。如需转载，请注明出处并链接回爆料专区原文。商业用途的转载需提前获得我们的书面授权。',
    },
  ];

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map(item => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: `关于${siteInfo.name}`,
    description: siteInfo.description,
    url: 'https://baoliao.example.com/about',
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />

      <div className="pt-16">
        <Breadcrumb items={breadcrumbItems} />

        <section className="px-4 md:px-6 py-10 md:py-14 bg-accent-500">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-2xl md:text-4xl font-bold text-background-50 mb-4">关于{siteInfo.name}</h1>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-2xl mx-auto">
              {siteInfo.description}
            </p>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10">
              {[
                { value: siteInfo.founded, label: '创立于' },
                { value: siteInfo.teamSize, label: '团队成员' },
                { value: siteInfo.dailyVisitors, label: '日活用户' },
                { value: siteInfo.totalArticles, label: '累计爆料' },
              ].map((stat, i) => (
                <div key={i} className="text-center p-4 rounded-lg bg-background-100">
                  <div className="text-xl md:text-2xl font-bold text-primary-500 mb-1">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            <h2 className="text-xl font-bold text-foreground-950 mb-4">品牌故事</h2>
            <div className="text-sm text-foreground-700 leading-relaxed space-y-4">
              <p>
                {siteInfo.name}创立于{siteInfo.founded}年，是国内领先的新闻爆料聚合平台。我们致力于打破信息壁垒，
                让每一个人都能第一时间获取最真实的独家资讯。从娱乐八卦到社会热点，从科技内幕到财经秘闻，
                我们覆盖了大众最关心的各个领域。
              </p>
              <p>
                我们拥有一支{siteInfo.teamSize}的专业新闻团队和遍布全国的爆料人网络。每一位编辑都秉持"真实第一、
                速度第二"的原则，对每一条爆料进行严格的多方核实后再发布。正是这种对新闻真实性的执着追求，
                让我们赢得了超过{siteInfo.dailyVisitors}用户的信任。
              </p>
              <p>
                在这个信息爆炸的时代，我们不追求数量，而是在意每一条爆料的质量和独特性。从明星恋情到企业内幕，
                从食品安全到行业黑幕，我们累计发布了{siteInfo.totalArticles}内容，其中超过98%为独家首发。
              </p>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl font-bold text-foreground-950 mb-4">用户口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                { name: '张先生', role: '资深媒体人', comment: '爆料专区是我每天必看的新闻平台，这里的独家内容确实比大部分媒体都快一步，而且准确度很高。' },
                { name: '李女士', role: '互联网从业者', comment: '在爆料专区找到了很多科技圈的内幕消息，比行业媒体还快，已经成为我们团队的信息源之一。' },
                { name: '王同学', role: '大学生', comment: '吃瓜必备！每天都来刷几次，娱乐八卦更新特别快，而且内容质量比微博靠谱多了。' },
                { name: '赵总', role: '投资人', comment: '财经板块的独家爆料对我的投资决策帮助很大，很多信息在正式公告前就能在这里找到蛛丝马迹。' },
              ].map((review, i) => (
                <div key={i} className="p-4 md:p-5 bg-background-50 rounded-lg">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500 font-bold text-sm">
                      {review.name[0]}
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{review.name}</div>
                      <div className="text-xs text-foreground-500">{review.role}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    "{review.comment}"
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl font-bold text-foreground-950 mb-4">联系我们</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
              <div className="p-5 rounded-lg bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-500">{siteInfo.email}</p>
              </div>
              <div className="p-5 rounded-lg bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">爆料热线</h3>
                <p className="text-xs text-foreground-500">{siteInfo.phone}</p>
              </div>
              <div className="p-5 rounded-lg bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">办公地址</h3>
                <p className="text-xs text-foreground-500">{siteInfo.address}</p>
              </div>
            </div>

            <h3 className="text-lg font-bold text-foreground-950 mb-4">给我们留言</h3>
            <form
              className="space-y-4"
              data-readdy-form
              action="https://readdy.ai/api/form/d9oqtq8senbnioleskag"
              method="POST"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="about-name" className="block text-sm text-foreground-700 mb-1.5">姓名</label>
                  <input
                    id="about-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 transition-colors duration-200"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="about-email" className="block text-sm text-foreground-700 mb-1.5">邮箱</label>
                  <input
                    id="about-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 transition-colors duration-200"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="about-subject" className="block text-sm text-foreground-700 mb-1.5">主题</label>
                <input
                  id="about-subject"
                  name="subject"
                  type="text"
                  required
                  className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 transition-colors duration-200"
                  placeholder="请输入留言主题"
                />
              </div>
              <div>
                <label htmlFor="about-message" className="block text-sm text-foreground-700 mb-1.5">留言内容</label>
                <textarea
                  id="about-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 transition-colors duration-200 resize-none"
                  placeholder="请输入您的留言（最多500字）"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1">最多500字符</p>
              </div>
              <div>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="absolute opacity-0 pointer-events-none"
                />
                <button
                  type="submit"
                  className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
                >
                  发送留言
                </button>
              </div>
            </form>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl font-bold text-foreground-950 mb-6">常见问题</h2>
            <div className="space-y-3">
              {faqItems.map((faq, i) => (
                <details key={i} className="group bg-background-50 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer">
                    <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}